import { render, staticRenderFns } from "./FabricDetailTableRow.vue?vue&type=template&id=7b1046be&scoped=true&"
import script from "./FabricDetailTableRow.vue?vue&type=script&lang=js&"
export * from "./FabricDetailTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1046be",
  null
  
)

export default component.exports